import React, { useState, useEffect } from "react";
import "./basicProfile.css";
import {
  TextInputField,
  TextInput,
  Select,
  option,
  FilePicker,
} from "evergreen-ui";
import SaveBTN from "./SaveBtn/SaveBTN";
import SubmitButton from "../../Buttons/SubmitButton/SubmitButton";

const ContactInfo = ({ allData, setAllData, handleProfileUpdate }) => {
  const [switchEdit, setswitchEdit] = useState(false);
  const [getAllData, setgetAllData] = useState(allData);
  const handleBasicProfile = (e) => {
    const { name, value } = e.target;
    setAllData({
      ...allData,
      [name]: value,
    });
  };
  const saveHandler = () => {
    handleProfileUpdate();
    setswitchEdit(false);
  };
  useEffect(() => {}, []);
  useEffect(() => {}, [switchEdit]);

  return (
    <div className="basicProfileMainContainer">
      <div className="basicProfileFirtRow">
        <div className="basicProfileMainContainerHead">
          <div>
            <img src="./images/stratum/contactDetails.svg" alt="" />
          </div>
          <div className="basicdetailName">Contact Info</div>
        </div>
        {!switchEdit ? (
          <div
            className="editInPf"
            onClick={() => {
              setswitchEdit(true);
            }}
          >
            <img src="./images/stratum/edit.svg" alt="" />
          </div>
        ) : (
          <div
            className="editInPf"
            onClick={() => {
              setswitchEdit(false);
            }}
          >
            <img src="./images/stratum/closeLogo.svg" alt="" />
          </div>
        )}
      </div>
      <div className="detailsColumInProfile">
        <div>
          <p className="subHeadProfileTab"> Contact Person</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.contactPerson ? allData.contactPerson : "NA"}
            </div>
          ) : (
            <TextInput
              className="pfInputManage"
              width={279}
              height={32}
              placeholder="Contact Person"
              name="contactPerson"
              value={allData.contactPerson}
              onChange={handleBasicProfile}
              required
            />
          )}
        </div>
        <div>
          {" "}
          <p className="subHeadProfileTab">Email</p>
          {!switchEdit ? (
            <div className="inputDesabledDta maxEmailLength">
              {allData.email ? allData.email : "NA"}
            </div>
          ) : (
            <TextInput
              disabled
              className="pfInputManage"
              width={279}
              height={32}
              placeholder="Email"
              name="email"
              value={allData.email}
              onChange={handleBasicProfile}
              required
            />
          )}
        </div>
        <div>
          {" "}
          <p className="subHeadProfileTab">Contact Number</p>
          {!switchEdit ? (
            <div className="inputDesabledDta">
              {allData.contactNumber ? allData.contactNumber : "NA"}
            </div>
          ) : (
            <TextInput
              className="pfInputManage"
              width={279}
              height={32}
              placeholder="Contact Number"
              name="contactNumber"
              value={allData.contactNumber}
              onChange={handleBasicProfile}
              required
            />
          )}
        </div>
      </div>
      {switchEdit && (
        <div className="btnmarginPf">
          {/* <SaveBTN handlesave={saveHandler} /> */}
          <SubmitButton ApplyFunction={saveHandler} text={"Save Changes"} />
        </div>
      )}
    </div>
  );
};

export default ContactInfo;
